import * as InactivityActions from "actions/InactivityActions";
import * as PlaybackStateActions from "actions/PlaybackStateActions";
import getShowSlideshowGalleryImages from "selectors/breakpoint/getShowSlideshowGalleryImages";
import ToggleGalleryViewButton from "components/Slideshow/ToggleGalleryViewButton";
import { connect } from "react-redux";
import { setSlideshowGalleryToggle } from "actions/ModalActions";

const mapStateToProps = (state, ownProps) => ({
  hide: !getShowSlideshowGalleryImages(state, ownProps),
  on: state.modals.slideshowGalleryToggle,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick(on) {
    const playing = on;
    dispatch(InactivityActions.reportUIActivity());
    dispatch(PlaybackStateActions.changePlaybackState(ownProps, { playing }));
    dispatch(setSlideshowGalleryToggle(!on));
  },
});

const mergeProps = (state, dispatchProps, ownProps) => {
  const { on } = state;

  return {
    ...ownProps,
    ...state,
    onClick: () => {
      const newValue = !on;

      // Execute callbacks for analytics
      if (newValue) {
        ownProps.onOpen && ownProps.onOpen();
      } else {
        ownProps.onClose && ownProps.onClose();
      }

      dispatchProps.onClick(on);
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default connector(ToggleGalleryViewButton);
